import { OrganizationAndUserRegistrationDto } from '@markant-platform/registration/model';
import { Industry, SalutationType } from 'data-model';

export const MOCK_REGISTER_RESULT: OrganizationAndUserRegistrationDto = {
  organization: {
    address: {
      city: 'Musterstadt',
      countryCode: 'DE',
      street: 'TestStreet',
      streetNumber: '12a',
      zipCode: '123456',
    },
    gln: '4260304620007',
    name: 'MusterCompany',
    industry: Industry.DEALER,
    phone: '+123456789',
    salesTaxId: 'DE659845785',
    taxNumber: null,
  },
  user: {
    email: 'test@test.de',
    firstname: 'Tester',
    language: 'en-gb',
    lastname: 'Test',
    salutation: SalutationType.m,
  },
  captchaToken: 'test-token',
  termsOfUseAccepted: true,
  privacyPolicyAcknowledged: true,
};
